export default "__VITE_PUBLIC_ASSET__21eeeff9__"